import React, { useState, useEffect } from "react";
import {
    Table,
    Button,
    Space,
    Card,
    Popconfirm,
    Form,
    notification,
    Modal,
    Input,
    DatePicker,
    Select,
    Flex,
} from "antd";
import {
    DeleteOutlined,
    EditOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import moment from "moment";
import axios from "axios";

const CouponsTable = ({ fetchCoupons, coupons = [], products = [] }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [editingCoupon, setEditingCoupon] = useState(null);
    const [discountType, setDiscountType] = useState("fixed"); // default for create
    const currentFormValues = form.getFieldsValue()
    // --- Create or Update Coupon ---
    const handleSaveCoupon = async (values) => {
        console.log(values);

        try {
            setIsSubmitting(true);
            console.log(values);
            const payload = {
                name: values.name,
                percent_off: values.percent_off || null,
                amount_off: values.amount_off ? values.amount_off * 100 : null,
                currency: "usd",
                duration: values.duration,
                redeem_by: values.redeem_by ? values.redeem_by.unix() : null,
                product_ids: values.product_ids || [],   // 👈 Add this
                couponId: values?.id,
                max_redemptions: values?.max_redemptions || null,
                durationInMonths:values.duration_in_months || null

            };
            let response;
            console.log(payload)
            // if (values?.couponId) {
            //     // Update existing
            //     response = await axios.put(
            //         `/api/coupon/update/${values.couponId}`,
            //         payload
            //     );
            // } else {
            response = await axios.post("/api/coupon/create", payload);
            // }

            if (response.data) {
                notification.success({
                    message: "Success",
                    description: editingCoupon
                        ? "Coupon updated successfully!"
                        : "Coupon created successfully!",
                });
                setModalVisible(false);
                setEditingCoupon(null);
                form.resetFields();
                fetchCoupons();
            } else {
                throw new Error(response.data.message || "Failed to save coupon");
            }
        } catch (error) {
            console.error("Error saving coupon:", error);
            notification.error({
                message: "Error",
                description:
                    error.response?.data?.message ||
                    "Failed to save coupon. Please try again.",
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    // --- Delete Coupon ---
    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`/api/delete/coupons/${id}`);
            if (response.data.success) {
                notification.success({
                    message: "Deleted",
                    description: "Coupon deleted successfully!",
                });
                fetchCoupons();
            } else {
                throw new Error("Failed to delete coupon");
            }
        } catch (error) {
            console.error("Error deleting coupon:", error);
            notification.error({
                message: "Error",
                description:
                    error.response?.data?.message ||
                    "Failed to delete coupon. Please try again.",
            });
        }
    };

    // --- Columns ---
    const columns = [
        {
            title: "🎟️",
            key: "icon",
            width: 50,
            align: "center",
            render: () => <span style={{ fontSize: "16px" }}>🎟️</span>,
        },
        {
            title: "Coupon ID",
            dataIndex: "id",
            key: "id",
            width: 160,
            render: (id) => <span style={{ fontWeight: "bold" }}>{id}</span>,
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            width: 200,
            render: (text) => text || "—",
        },
        {
            title: "Discount",
            key: "percent_off",
            width: 120,
            render: (_, record) => {
                if (record.percent_off) return `${record.percent_off}% Off`;
                if (record.amount_off)
                    return `$${(record.amount_off / 100).toFixed(2)} Off`;
                return "—";
            },
        },
        {
            title: "Duration",
            key: "duration",
            width: 120,
            render: (_, record) => {
                if (record.duration === "repeating") {
                    return `Repeating (${record.duration_in_months} months)`;
                }
                return record.duration.charAt(0).toUpperCase() + record.duration.slice(1);
            },
        },
        {
            title: "Expiration",
            dataIndex: "redeem_by",
            key: "redeem_by",
            width: 140,
            render: (timestamp) =>
                timestamp ? moment.unix(timestamp).format("MMM DD, YYYY") : "—",
        },
        {
            title: "Created",
            dataIndex: "created",
            key: "created",
            width: 140,
            render: (ts) => moment.unix(ts).format("MMM DD, YYYY"),
        },
        {
            title: "Redeemed",
            dataIndex: "times_redeemed",
            key: "times_redeemed",
            width: 100,
            align: "center",
            render: (count) => <span>{count}</span>,
        },
        {
            title: "Status",
            dataIndex: "valid",
            key: "valid",
            width: 100,
            render: (valid) => (
                <span style={{ color: valid ? "green" : "red", fontWeight: "500" }}>
                    {valid ? "Active" : "Expired"}
                </span>
            ),
        },
        {
            title: "Action",
            key: "action",
            width: 160,
            fixed: "right",
            render: (_, record) => (
                <Space>
                    {/* <Button
                        size="small"
                        icon={<EditOutlined />}
                        onClick={() => {
                            setEditingCoupon(record);
                            setModalVisible(true);
                            form.setFieldsValue({
                                ...record,
                                redeem_by: record.redeem_by
                                    ? moment.unix(record.redeem_by)
                                    : null,
                                amount_off: record.amount_off ? record.amount_off / 100 : null,
                                percent_off: record.percent_off ? record.percent_off : null,
                                discountType: record.percent_off ? "percentage" : "fixed",
                                discountType: record.percent_off ? "percentage" : "fixed",
                                couponId:record?.id
                                // productsIds: product.applies_to?.products
                                //     ? record.applies_to.products   // Stripe style
                                //     : record.products || [],       // If you stored products manually
                            });
                        }}
                    >
                        Edit
                    </Button> */}
                    <Popconfirm
                        title="Are you sure you want to delete this coupon?"
                        onConfirm={() => {
                            debugger
                            handleDelete(record.id)
                        }}
                        okText="Yes"
                        cancelText="Cancel"
                    >
                        <Button danger size="small" icon={<DeleteOutlined />}>
                            Delete
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: "20px", backgroundColor: "#f5f5f5" }}>
            {/* Create Button */}
                <Flex justify='flex-end' align="flex-end" style={{ width: '100%', marginBottom: 10 }}>
                <Button
                    size="large"
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                        setEditingCoupon(null);
                        setModalVisible(true);
                        form.resetFields();
                    }}
                    style={{ backgroundColor: "black", borderColor: "black" }}
                >
                    Create New Coupon
                </Button>
            </Flex>
              

            {/* Table Card */}
            <Card
                style={{ borderRadius: "8px", border: "2px solid #ccc" }}
                bodyStyle={{ padding: 0 }}
            >
                {/* Header */}
                <div style={{
                    backgroundColor: 'rgb(206, 46, 40)',
                    color: 'white',
                    padding: '12px 20px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textAlign: 'center'
                }}>
                    Coupons Management
                </div>

                {/* Status Bar */}
                <div style={{
                    backgroundColor: '#e8e8e8',
                    padding: '12px 20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #ddd'
                }}>
                    <span style={{ fontWeight: 'bold' }}>
                        Total Coupons: <span style={{ fontWeight: 'normal' }}>{coupons?.length}</span>
                    </span>

                </div>
                <Table
                    dataSource={coupons}
                    columns={columns}
                    rowKey="id"
                    pagination={{
                        pageSize: 10,
                        showTotal: (total, range) =>
                            `${range[0]}-${range[1]} of ${total} coupons`,
                    }}
                    scroll={{ x: "max-content" }}
                    size="small"
                />
            </Card>

            {/* Create / Edit Modal */}
            <Modal
                title={editingCoupon ? "Edit Coupon" : "Create New Coupon"}
                open={modalVisible}
                onCancel={() => {
                    setModalVisible(false);
                    setEditingCoupon(null);
                    form.resetFields();
                }}
                footer={null}
                width={650}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSaveCoupon}
                    requiredMark={false}
                    initialValues={{
                        duration: "once",
                    }}
                >
                    {/* Name */}
                    <Form.Item
                        label="Coupon Name"
                        name="name"
                        rules={[{ required: true, message: "Please enter a coupon name!" }]}
                    >
                        <Input placeholder="e.g. Summer Sale, Loyalty Discount" />
                    </Form.Item>
                    {/* coupon id */}

                    <Form.Item name="id" hidden>
                        <Input hidden />
                    </Form.Item>


                    {/* Always show input depending on selected discountType */}
                    <Form.Item
                        label="Discount Type"
                        name="discountType"
                        initialValue={editingCoupon?.percent_off ? "percentage" : "fixed"}
                        rules={[{ required: true, message: "Please select a discount type!" }]}
                    >
                        <Select
                            placeholder="Select discount type"
                            onChange={(value) => {
                                if (value === "percentage") {
                                    form.setFieldsValue({ amount_off: null });
                                } else {
                                    form.setFieldsValue({ percent_off: null });
                                }
                            }}
                        >
                            <Select.Option value="percentage">Percentage</Select.Option>
                            <Select.Option value="fixed">Fixed Amount</Select.Option>
                        </Select>
                    </Form.Item>

                    {/* Always show input depending on selected discountType */}
                    {Form.useWatch("discountType", form) === "percentage" ? (
                        <Form.Item
                            label="Percentage Off (%)"
                            name="percent_off"
                            rules={[{ required: true, message: "Please enter percentage!" }]}
                        >
                            <Input type="number" placeholder="e.g. 20" />
                        </Form.Item>
                    ) : (
                        <Form.Item
                            label="Amount Off"
                            name="amount_off"
                            rules={[{ required: true, message: "Please enter amount!" }]}
                        >
                            <Input type="number" placeholder="e.g. 500 (in cents)" />
                        </Form.Item>
                    )}

                    {/* apply to specific product */}
                    <Form.Item
                        label="Apply to Products"
                        name="product_ids"
                        rules={[{ required: true, message: "Please select at least one product!" }]}
                    >
                        <Select
                            mode="multiple"
                            placeholder="Select products"
                            optionFilterProp="children"
                        >
                            {products.map((product) => (
                                <Select.Option key={product.id} value={product.id}>
                                    {product.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {/* Duration */}
                    <Form.Item
                        label="Duration"
                        name="duration"
                        rules={[{ required: true, message: "Please select duration!" }]}
                    >
                        <Select>
                            <Select.Option value="once">Once</Select.Option>
                            <Select.Option value="repeating">Repeating</Select.Option>
                            <Select.Option value="forever">Forever</Select.Option>
                        </Select>
                    </Form.Item>

                    {/* Duration in months (only when repeating) */}
                   {Form.useWatch("duration", form) === "repeating" && (
                        <Form.Item
                            label="Duration in Months"
                            name="duration_in_months"
                            rules={[{ required: true, message: "Please enter duration in months!" }]}
                        >
                            <Input type="number" min={1} placeholder="e.g. 3" />
                        </Form.Item>
                    )}
                    {/* Expiration Date (optional) */}
                    <Form.Item label="Expiration Date (optional)" name="redeem_by">
                        <DatePicker style={{ width: "100%" }} />
                    </Form.Item>

                    {/* Max Redemptions (optional) */}
                    <Form.Item
                        label="Max Redemptions (optional)"
                        name="max_redemptions"
                        rules={[
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value) {
                                        // Allow empty (optional field)
                                        return Promise.resolve();
                                    }
                                    if (Number(value) >= 1) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error("Must be greater than 0"));
                                },
                            }),
                        ]}
                    >
                        <Input type="number" placeholder="e.g. 100" />
                    </Form.Item>

                    {/* Buttons */}
                    <Form.Item style={{ textAlign: "right" }}>
                        <Space>
                            <Button
                                onClick={() => {
                                    setModalVisible(false);
                                    form.resetFields();
                                    setEditingCoupon(null);
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={isSubmitting}
                                style={{ backgroundColor: "black", borderColor: "black" }}
                            >
                                {editingCoupon ? "Update Coupon" : "Create Coupon"}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>

        </div>
    );
};

export default CouponsTable;
